import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);


// state
import state from "./state/state"

// getters
import getter_getters from "./getters/getters"

// mutations
import mutation_mutations from "./mutations/mutations"

// actions
import action_actions from "./actions/actions"



export default new Vuex.Store({

	state: {
		...state
	},

	getters: {
		...getter_getters,
	},

	mutations: {
		...mutation_mutations,
	},

	actions: {
		...action_actions,
	}


});